/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Handler<
    | ({
          cartId: string;
          shouldLoadFullCart?: boolean;
      } & HasOnSuccess)
    | ({
          apiParameter: GetCartApiParameter;
      } & HasOnSuccess),
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const XngPopulateApiParameter: HandlerType = props => {
    if ("apiParameter" in props.parameter) {
        props.apiParameter = props.parameter.apiParameter;
        return;
    }

    props.apiParameter = {
        cartId: props.parameter.cartId,
        expand: ["validation"],
    };

    if (props.needFullCart) {
        const pageType = getCurrentPage(props.getState()).type;
        const cartSettings = props.getState().context.settings.settingsCollection.cartSettings;

        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "carriers",
            "paymentOptions",
            "creditCardBillingAddress",
        ];

        if (cartSettings.showTaxAndShipping || pageType !== "CartPage") {
            props.apiParameter.expand.push("shipping", "tax");
        }
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
